import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject, take } from 'rxjs'
import { ApiService } from './api.service';
import { SnackBarService } from './snack-bar.service';

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  currentMessage = new BehaviorSubject(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private apiService: ApiService,
    private snackBar: SnackBarService) {
  }

  //get token from fcm
  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log("Permission granted! Token: ", token);
      },
      (err) => {
        console.error("Unable to get permission to notify.", err);
      }
    );
  }

  //recieve message from FCM
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((message: any) => {
      if (message) {
        console.log("new message received in cons. ", message?.data);
        console.log(message);
        if (message?.notification) {
          this.snackBar.openSnackBar(message?.notification?.body);
        } else if (message?.data) {
          this.snackBar.openSnackBar(message?.data?.body);
        }
      }
    });
  }

  register(userId: string) {
    this.angularFireMessaging.requestToken.pipe(take(1)).subscribe(
      (token) => {
        if (token) {
          this.sendTokenToServer(userId, token);
        }
      },
      (err) => {
        console.error("Unable to get permission to notify.", err);
      }
    );
  }

  deregister(userId: string) {
    this.angularFireMessaging.getToken.pipe(take(1)).subscribe(
      (token) => {
        if (token) {
          this.deleteTokenFromServer(userId, token);
          this.angularFireMessaging.deleteToken(token);
        }
      }
    );
  }

  //send fcm token to the server 
  sendTokenToServer(userId: string, token: string) {
    console.log("token", token);
    if (token && userId) {
      const payload = {
        userId: userId,
        userType: 'ADMIN',
        platform: 'WEB',
        deviceToken: token,
        deviceId: token // Using token as deviceId for web
      };

      this.apiService.sendPOSTRequest('/v1/Devices/register', payload).subscribe(
        (response) => {
          console.log('Device registered successfully', response);
        },
        (error) => {
          console.error('Error registering device', error);
        }
      );
    }
  }

  deleteTokenFromServer(userId: string, token: string) {
    if (token && userId) {
      const payload = {
        userId: userId,
        deviceToken: token
      };

      // Assuming /deregister endpoint exists or using appropriate logic
      this.apiService.sendPOSTRequest('/v1/Devices/deregister', payload).subscribe(
        (response) => {
          console.log('Device deregistered successfully', response);
        },
        (error) => {
          console.error('Error deregistering device', error);
        }
      );
    }
  }

}
